module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/whatsapp-icon-e45e517704a44c58acead7521899fc02.png";